import * as React from 'react';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import {
  Button,
  cn,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  PasswordInput,
} from '@sandtech-hub-monorepo/ui-kit';

const formSchema = z.object({
  challengeResponse: z
    .string()
    .min(6, 'Oops! It looks like you forgot to enter your password'),
});

interface CreatePasswordFormProps {
  onSubmit: (values: z.infer<typeof formSchema>) => void;
  loading: boolean;
  className?: string;
  resetPasswordRoute: string;
}

export const CreatePasswordForm = ({
  className,
  loading,
  onSubmit,
  resetPasswordRoute,
  ...props
}: CreatePasswordFormProps) => {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      challengeResponse: '',
    },
  });

  return (
    <div className={cn('grid gap-4 text-foreground', className)} {...props}>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <FormField
            control={form.control}
            name="challengeResponse"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="font-normal">New password</FormLabel>
                <FormControl>
                  <PasswordInput disabled={loading} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button disabled={loading} type="submit" className="w-full">
            Sign in
          </Button>
        </form>
      </Form>
    </div>
  );
};
